import { IconNames } from '@blueprintjs/icons';
import { PrimaryData } from '@strata/react-grid';
import { Icon } from '@strata/react-status-icons';
import { Tooltip } from '@strata/react-tooltip';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import { windowTooltip } from 'services/TherapyGroupPreferenceHelpers';

const entryLabel = (segmentId) =>
    segmentId === null ? (
        <>
            <Icon icon={IconNames.STAR} /> <span>Global default</span>
        </>
    ) : (
        <span>{segmentId}</span>
    );

// Any entry with a loaded window shows its own dates on hover.
const PreferenceEntry = ({ entry }) => {
    const label = entryLabel(entry.segmentId);
    return entry.window ? <Tooltip content={windowTooltip(entry.window)}>{label}</Tooltip> : label;
};

const entryShape = PropTypes.shape({
    segmentId: PropTypes.string,
    window: PropTypes.shape({
        preferenceId: PropTypes.string,
        start: PropTypes.string.isRequired,
        end: PropTypes.string,
    }),
});

PreferenceEntry.propTypes = {
    entry: entryShape.isRequired,
};

// PrimaryData would otherwise repeat the whole list in its own tooltip on top of each entry's.
// The wrapper's class lets the list wrap instead of truncating (see _therapy-group.scss).
export const ClientPreferenceCell = ({ entries }) => (
    <div className="sds_therapy-group__client-preference">
        <PrimaryData
            customTooltipContent={null}
            data={
                <>
                    {entries.map((entry, index) => (
                        <Fragment key={entry.segmentId ?? 'global'}>
                            {index > 0 && ', '}
                            <PreferenceEntry entry={entry} />
                        </Fragment>
                    ))}
                </>
            }
        />
    </div>
);

ClientPreferenceCell.propTypes = {
    entries: PropTypes.arrayOf(entryShape).isRequired,
};
